import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import TranslatedText from '../../atoms/TranslatedText';

export default class TruBridgeSizing extends PureComponent {
    componentDidMount() {
        ReactGA.pageview('Trubridge - Sizing');
    }
    render() {
        const {
            style,
            currentType,
            currentSlide,
            changeBridge,
            handleSlide,
            slides,
        } = this.props;

        const prev = (
            <button
                onClick={() => handleSlide('prev')}
                className="TruBridge-slide-prev">
                <span>Prev</span>
            </button>
        );
        const next =
            currentSlide !== 3 ? (
                <button
                    onClick={() => handleSlide('next')}
                    className="TruBridge-slide-next">
                    <span>Next</span>
                </button>
            ) : (
                ''
            );

        return (
            <div className="TruBridgeContainer">
                <div className="TruBridge-bg" style={style} />
                <div className="TruBridge-content">
                    <div className="TruBridgeTop">
                        <h3 className="top-title">
                            <TranslatedText tag={currentType.title} />
                        </h3>
                        <h4 className="top-subtitle">
                            <TranslatedText
                                tag={
                                    currentType.slides[currentSlide].description
                                }
                            />
                        </h4>
                    </div>
                    <div className="TruBridge-slides">{slides}</div>
                    <div className="TruBridge-action">
                        <TranslatedText tag={currentType.actionLabel} />
                    </div>
                    <button
                        className="TruBridge-reset"
                        onClick={() => changeBridge(0)}>
                        <TranslatedText tag={currentType.resetLabel} />
                    </button>

                    {prev}
                    {next}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/trueBridge/TruBridgeSizing.js